(ns dre.pages.frontpage.topic-search.views
  (:require [clojure.string]
            [dre.components.icon :refer [svg]]
            [dre.i18n.views :refer [tr]]
            [dre.pages.frontpage.topic-search.events :as events]
            [dre.pages.frontpage.topic-search.views.topic-forms :as forms]
            [dre.utils.bem :as bem]
            [re-frame.core :as rf]))

(def component-name :topic-search)

(defn topic-button
  [topic-name]
  (let [topics-map events/topics-map]
    [:a
     {:class (bem/be component-name :button)
      :href "#"
      :key topic-name
      :on-click #(rf/dispatch [::events/expand-topic topic-name])}
     [:span
      {:class (bem/be component-name :button-icon)}
      [svg :topic-search topic-name]]
     [:span 
      {:class (bem/be component-name :button-title)}
      (get-in topics-map [topic-name :title])]]))

(defn topic-selection
  []
  (let [topics-map events/topics-map
        topics (keys topics-map)]
    [:<>
     [:p
      {:class (bem/be component-name :title)}
      [tr "Please select a topic to start building your question"]]
     [:div.box
      {:class (bem/be component-name :selection)}
      (doall
       (map topic-button (take 6 topics)))]])) 

(defn view
  []
  (let [selected-view @(rf/subscribe [::events/selected-view])]
    [:div
     {:class component-name}
     (condp = selected-view
       :topics [topic-selection]
       :forms [forms/view]
       [topic-selection])]))

